import { AxiosError } from "axios";
import { useQuery, useQueryClient, UseQueryResult } from "react-query";
import { getFullAccountsInfo } from "./getFullAccountsInfo";
import { getMinimalAccountsInfo } from "./getMinimalAccountsInfo";
import { Account } from "./types";

interface Params {
  fullCreditCardsInfo?: boolean;
  fullPersonalLoansInfo?: boolean;
  enabled?: boolean;
}
export function useAccounts({
  fullCreditCardsInfo = false,
  fullPersonalLoansInfo = false,
  enabled,
}: Params = {}): UseQueryResult<
  {
    credit_cards: Account[];
    personal_loans: Account[];
  },
  AxiosError
> {
  const queryClient = useQueryClient();
  const accountsInfo = useQuery<
    { credit_cards: Account[]; personal_loans: Account[] },
    AxiosError
  >(
    ["accounts", { fullCreditCardsInfo, fullPersonalLoansInfo }],
    () =>
      fullCreditCardsInfo || fullPersonalLoansInfo
        ? getFullAccountsInfo({
            queryClient,
            fullCreditCardsInfo,
            fullPersonalLoansInfo,
          })
        : getMinimalAccountsInfo(),
    {
      ...(typeof enabled === "boolean" ? { enabled } : {}),
    },
  );

  return accountsInfo;
}
